module.exports = __webpack_public_path__ + "static/media/archive-dark.3a74f730.png";